/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
import Component from '@glimmer/component';
import { sort, filter, uniqBy } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class PlaylistListComponent extends Component {
  @tracked searchValue = '';
  @tracked state = 'open';

  @uniqBy('args.playlists', 'id') uniquePlaylists;

  createdAtSorting = ['createdAt:desc'];
  @sort('filteredPlaylists', 'createdAtSorting') sortedPlaylists;

  @action
  setSearch(searchValue) {
    this.searchValue = searchValue;
  }

  @action
  setPlaylistState(state) {
    this.state = state;
  }

  get filteredPlaylists() {
    console.log('filtering playlists...', this.uniquePlaylists, this.state);

    let playlists = this.uniquePlaylists;
    let filteredPlaylists = playlists;

    if (this.searchValue != '') {
      var pattern = new RegExp(this.searchValue, 'i');
      filteredPlaylists = filteredPlaylists.filter(
        function (item, index, enumerable) {
          var data = item.get('name');
          return pattern.test(data);
        },
      );
    }

    return filteredPlaylists;
  }
}
